var _rect, _rect2, _line, _rect3, _rect4, _circle, _rect5, _line2, _circle2, _rect6, _line3, _circle3, _rect7, _line4, _circle4, _rect8, _line5, _circle5, _rect9, _line6, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobileMyNewsPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 335,
  height: 794,
  viewBox: "0 0 335 794",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.501953,
  width: 334,
  height: 793,
  rx: 7.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20.002,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 51.502,
  x2: 20,
  y2: 51.5019,
  stroke: "black"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 71.002,
  width: 160,
  height: 29,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 108.002,
  width: 261,
  height: 16,
  fill: "#E5E5E5"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 154.002,
  r: 10,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 144.002,
  width: 263,
  height: 70,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 234.502,
  x2: 20,
  y2: 234.502,
  stroke: "#E5E5E5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 264.002,
  r: 10,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 254.002,
  width: 263,
  height: 70,
  fill: "#E5E5E5"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 344.502,
  x2: 20,
  y2: 344.502,
  stroke: "#E5E5E5"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 374.002,
  r: 10,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 364.002,
  width: 263,
  height: 70,
  fill: "#E5E5E5"
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 454.502,
  x2: 20,
  y2: 454.502,
  stroke: "#E5E5E5"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 484.002,
  r: 10,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 474.002,
  width: 263,
  height: 70,
  fill: "#E5E5E5"
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 564.502,
  x2: 20,
  y2: 564.502,
  stroke: "#E5E5E5"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 594.002,
  r: 10,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 584.002,
  width: 263,
  height: 70,
  fill: "#E5E5E5"
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 674.502,
  x2: 20,
  y2: 674.502,
  stroke: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 694.002,
  width: 160,
  height: 30,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 744.002,
  width: 295,
  height: 30,
  fill: "#E5E5E5"
})));
export default SvgMobileMyNewsPlaceholder;